// Template Generated by DataExtraction.py at 1721092908

import RDIEn11 from "../../Forms/RDI/RDI_En11.png";
import RDIEn11Labels from "../../Labels/RDI/RDI_En11.json";
import RDIFr11 from "../../Forms/RDI/RDI_Fr11.png";
import RDIFr11Labels from "../../Labels/RDI/RDI_Fr11.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? RDIFr11Labels : RDIEn11Labels;
    const formImage = isFrench ? RDIFr11 : RDIEn11;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;
    const subscriber2Include = common.subscriber2Include;

    // Drawing the form
    // TODO implement fields
    drawText(moment(new Date()).format("YYYY-MM-DD"), "drSignDate");
    drawText(moment(new Date()).format("YYYY-MM-DD"), "s1SignDate");
    if (common.subscriber2Include) {
        drawText(moment(new Date()).format("YYYY-MM-DD"), "s2SignDate");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? RDIFr11Labels : RDIEn11Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const common = state.common;
    const subscriber2Include = common.subscriber2Include;


    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2SignatureView", labels))],
        });
    }


    // drSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignatureView", labels))],
    });


    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1SignatureView", labels))],
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    
